import { render } from "./MenuMobile.vue?vue&type=template&id=2d9b8982&lang=pug"
import script from "./MenuMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMobile.vue?vue&type=script&setup=true&lang=js"

import "./MenuMobile.vue?vue&type=style&index=0&id=2d9b8982&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__